import { create } from "zustand";
import { IModule } from "../models";

type TAppStore = {
  allowedChannels: IModule[];
  setAllowedChannels: (args: IModule[]) => void;
};

const useAppStore = create<TAppStore>((set) => ({
  allowedChannels: [],

  setAllowedChannels: (payload: IModule[]) => {
    set({ allowedChannels: payload });
  },
}));

export default useAppStore;
